// extracted by mini-css-extract-plugin
export default {"root":"NavigationFormItems_root__bjue9","text":"NavigationFormItems_text__wM5ut"};